import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_TAXES_APP_ROOT = `${BASE_ADMIN_V2_PATH}/taxes`;

export const ADMIN_TAXES_APP_PATHS = {
  TAXES_LIST: `${ADMIN_TAXES_APP_ROOT}`,
};
